"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createItemExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const Item_1 = require("./__model__/Item");
const getItems_1 = tslib_1.__importDefault(require("../../../items/getItems"));
const utils_1 = require("../../../../utils");
const BookingItem_1 = tslib_1.__importDefault(require("./__model__/BookingItem"));
const refreshBooking_1 = tslib_1.__importDefault(require("../../bookings/refreshBooking"));
const disableItem_1 = tslib_1.__importDefault(require("../disableItem"));
const createItem = toolkitRaw.createAsyncThunk('item/create', async ({ data, options }, { rejectWithValue, dispatch }) => {
    try {
        const itemInstance = new Item_1.ItemCreate(data);
        await itemInstance.processImages();
        const response = await services_1.default.post(`/api/saas/me/items`, itemInstance.data, {
            params: {
                enable: true,
            },
        });
        const deserializedItem = (0, utils_1.deserialize)(response.data);
        dispatch((0, getItems_1.default)());
        if ((options === null || options === void 0 ? void 0 : options.shouldInactiveItem) && !(options === null || options === void 0 ? void 0 : options.bookingInternalId)) {
            (0, disableItem_1.default)({
                internalItemId: String(deserializedItem.data.internal_id),
            });
        }
        if (options === null || options === void 0 ? void 0 : options.bookingInternalId) {
            const bookingId = options === null || options === void 0 ? void 0 : options.bookingInternalId;
            const payload = new BookingItem_1.default(deserializedItem.data.id, deserializedItem.data.deposit_amount).data;
            await services_1.default.patch(`/api/saas/me/bookings/${bookingId}`, payload);
            await dispatch((0, refreshBooking_1.default)({ bookingInternalId: bookingId }));
        }
        return deserializedItem.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const createItemExtraReducers = (builder) => {
    builder.addCase(createItem.pending, (state) => {
        state.item.loading = true;
    });
    builder.addCase(createItem.fulfilled, (state) => {
        state.item.loading = false;
    });
    builder.addCase(createItem.rejected, (state) => {
        state.item.loading = false;
    });
};
exports.createItemExtraReducers = createItemExtraReducers;
exports.default = createItem;
//# sourceMappingURL=index.js.map